import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authFetch } from '../api';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Login = () => {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (isRegister) {
      if (!email.endsWith('@shiftcreative.ca') && !email.endsWith('@ascentech.ca')) {
        setError('Registration is restricted to @shiftcreative.ca and @ascentech.ca domains.');
        setLoading(false);
        return;
      }

      const res = await authFetch('sign-up/email', {
        method: 'POST',
        body: JSON.stringify({ email, password, name })
      });

      if (res?.status === 'success') {
        // Securely store the user_id upon successful registration
        localStorage.setItem('user_id', res.data.user.id);
        navigate('/');
      } else {
        setError(res?.error || 'Registration failed.');
      }
    } else {
      const res = await authFetch('sign-in/email', {
        method: 'POST',
        body: JSON.stringify({ email, password })
      });

      if (res?.status === 'success') {
        // Securely store the user_id upon successful login
        localStorage.setItem('user_id', res.data.user.id);
        
        // Trigger password reset prompt for the default password
        if (password === 'password123') {
           localStorage.setItem('needs_password_reset', 'true');
        } else {
           localStorage.removeItem('needs_password_reset');
        }
        
        navigate('/');
      } else {
        setError(res?.error || 'Login failed. Please check your credentials.');
      }
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8 max-w-md w-full shadow-2xl relative overflow-hidden">
        {/* Decorative background element */}
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="text-center mb-8 relative z-10">
          <div className="w-16 h-16 bg-slate-950 text-teal-400 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-teal-500/20 shadow-lg shadow-teal-900/20">
            <SafeIcon icon={FiIcons.FiLock} className="text-2xl" />
          </div>
          <h1 className="text-3xl font-black text-white">{isRegister ? 'Create Account' : 'Welcome Back'}</h1>
          <p className="text-slate-400 mt-2 text-sm font-medium">Shift Creative Portal</p>
        </div>

        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-xl mb-6 text-sm font-bold flex items-start gap-2 relative z-10">
            <SafeIcon icon={FiIcons.FiAlertCircle} className="shrink-0 mt-0.5" />
            <p>{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5 relative z-10">
          {isRegister && (
            <div>
              <label className="block text-xs font-black text-slate-500 uppercase tracking-widest mb-2">Full Name</label>
              <input 
                type="text" 
                required
                placeholder="John Doe"
                className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:ring-2 focus:ring-teal-500 outline-none transition-all text-sm"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
          )}
          
          <div>
            <label className="block text-xs font-black text-slate-500 uppercase tracking-widest mb-2">Email Address</label>
            <input 
              type="email" 
              required
              placeholder="name@shiftcreative.ca"
              className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:ring-2 focus:ring-teal-500 outline-none transition-all text-sm"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-xs font-black text-slate-500 uppercase tracking-widest mb-2">Password</label>
            <input 
              type="password" 
              required
              placeholder="••••••••"
              className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-3 text-white focus:ring-2 focus:ring-teal-500 outline-none transition-all text-sm"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-teal-600 hover:bg-teal-500 text-white rounded-xl py-3.5 font-black text-sm uppercase tracking-wider transition-all shadow-lg shadow-teal-900/20 disabled:opacity-50 flex justify-center items-center gap-2"
          >
            {loading ? <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" /> : null}
            {loading ? 'Processing...' : (isRegister ? 'Register' : 'Sign In')}
          </button>
        </form>

        <div className="mt-6 text-center relative z-10">
          <button 
            type="button"
            onClick={() => { setIsRegister(!isRegister); setError(''); }}
            className="text-slate-400 hover:text-teal-400 text-sm font-bold transition-colors"
          >
            {isRegister ? 'Already have an account? Sign In' : 'Need an account? Register'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;